export const AUTH_TOKEN = 'dashboardAuthToken'
export const AUTH_REFRESH_TOKEN = 'dashboardRefreshToken'
export const PERSIST_MODE = 'rememberMe'
export const USED_ID = 'dashboardUid'
export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
export const PASS_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,20}$/
export const INVALID_EMAIL_ADDRESS_TEXT = 'PLEASE ENTER VALID EMAIL ADDRESS'
export const INVALID_EMAIL_OR_PASSWORD_TEXT = 'Wrong email or temporary password'
export const PASSWORD_EQUALITY_ERROR_TEXT = '"CONFIRM PASSWORD" AND "NEW PASSWORD" DON`T MATCH'
export const PASSWORD_EQUALITY_ERROR_TEXT_2 = '"PASSWORD" AND "CONFIRM PASSWORD" DON`T MATCH'
export const PASSWORD_COMPLEXITY_ERROR_TEXT = 'PASSWORD MUST HAVE AT LEAST 8 CHARACTERS WITH AT LEAST ONE NUMBER AND ONE CAPITAL LETTER'
